import { Job } from "@prisma/client";
import { AudioVis1JobParameters } from "app/api/public/v1/audiovis1/types";
import { Shroom_JobParameters } from "app/api/public/v1/shroom/lib";
import { AnimationJobParameters, ImageJobParameters } from "app/types";
import { Prediction } from "replicate";

export type RunpodJob = {
    id: string,
    status: RunpodStatus,
    delayTime?: number,
    executionTime?: number,
    gpu?: string,
    output: Record<string, string>
}

export type RunpodStatus = 'IN_QUEUE' | 'COMPLETED' | 'IN_PROGRESS' | 'FAILED' | 'CANCELLED';

export type RunpodSubmissionResponse = {
    id: string
    status: RunpodStatus
}


export abstract class GpuFarm {

    static probabilities = {
        "replicate": parseFloat(process.env.GPU_FARM_P_REPLICATE ?? '0'),
        "runpod": parseFloat(process.env.GPU_FARM_P_RUNPOD ?? '1')
    }

    constructor() {
    }

    public abstract name : GpuFarmName;

    public abstract submitAnimationJob(jobId: string, jobRequest:AnimationJobParameters): Promise<GpuFarmSubmissionResponse>

    public abstract submitImageJob(jobId: string, jobRequest: ImageJobParameters): Promise<GpuFarmSubmissionResponse>;

    public abstract submitAudioVis1Job(jobId: string, jobRequest:AudioVis1JobParameters): Promise<GpuFarmSubmissionResponse>

    public abstract submitShroomJob(jobId: string, jobRequest:Shroom_JobParameters): Promise<GpuFarmSubmissionResponse>

    public abstract getJob(job: Job): Promise<GpuFarmJob>;

    public abstract cancelJob(job: Job): Promise<GpuFarmCancellationReponse>;

    public abstract mapStatus(gpuFarmSpecificStatus: string): GpuFarmJobStatusString;

    public abstract getOutput(gpuFarmJob: GpuFarmJob): any[] | Record<string, any>;

}

type Placeholder = object;

export type GpuFarmJob = {
    farm: GpuFarmName;
    externalId: string;
    status: GpuFarmJobStatusString;
    farmSpecific: Prediction | RunpodJob | Placeholder
}

export type GpuFarmSubmissionResponse = GpuFarmJob;
export type GpuFarmCancellationReponse = {
    externalId: string;
    status: GpuFarmJobStatusString;
};

export type GpuFarmName = 'runpod' | 'replicate' | "dummy";
export type GpuFarmJobStatusString = 'submitted' | 'starting' | 'processing' | 'canceled' | 'failed' | 'succeeded';
export const FINAL_STATUSES : GpuFarmJobStatusString[] = ['canceled', 'failed', 'succeeded'];